import { getHttpErrorClass, HttpErrorClass } from "./getHttpErrorClass";

interface ApiErrorArgs {
  status: number;
  endpoint: string;
  responseBody: unknown;
  message: string;
}

export class ApiError extends Error {
  readonly status: number;
  readonly endpoint: string;
  readonly responseBody: unknown;
  readonly errorClass: HttpErrorClass;

  constructor({ status, endpoint, responseBody, message }: ApiErrorArgs) {
    super(message);
    this.name = "ApiError";
    this.status = status;
    this.endpoint = endpoint;
    this.responseBody = responseBody;
    this.errorClass = getHttpErrorClass(status);
  }
}
